const PROD = process.env.NODE_ENV !== "development";

// Spotify no longer accepts "localhost" in redirect URIs -- the loopback
// address must be given explicitly as 127.0.0.1. Do not change these back:
// the value here feeds the OAuth redirect_uri, and it must match the
// redirect_uri the other side of the app sends during the token exchange.
const LOCALHOST = "http://127.0.0.1:3000";
const PROD_HOST = "https://vybe.link";

const LOCAL_API = "http://127.0.0.1:8080";
const PROD_API_HOST = "https://vybe.link";

export const HOST = PROD ? PROD_HOST : LOCALHOST;
export const API_HOST = PROD ? PROD_API_HOST : LOCAL_API;
